// extracted by mini-css-extract-plugin
module.exports = {"model-header":"style_model-header__2j4wN","header-content":"style_header-content__1HZUH","title":"style_title__1ZW_c"};